import config from '../config/config.json'
import superagent from 'superagent'
import * as c from '../constants/actionTypes';

const COUPON_DETAILS_GET = 'COUPON_DETAILS_GET';
const COUPON_DETAILS_SUCCESS = 'COUPON_DETAILS_SUCCESS';
const COUPON_DETAILS_FAILED = 'COUPON_DETAILS_FAILED';

export {
    COUPON_DETAILS_GET,
    COUPON_DETAILS_SUCCESS,
    COUPON_DETAILS_FAILED
  }
  
    export function getCouponDetailsRequest() {
        return {
        type: COUPON_DETAILS_GET,
        loading: true
        }
    }
    
    export function getCouponDetailsSuccess(body) {
        return {
        type: COUPON_DETAILS_SUCCESS,
        body: body,
        loading: false
        }
    }
    
    export function getCouponDetailsFailure(error) {
        return {
        type: COUPON_DETAILS_FAILED,
        error: error,
        loading: false
        }
    }
    
    export function getCouponDetails(couponId) {
        return function(dispatch) {
        dispatch(getCouponDetailsRequest())
        superagent
        .get(config.BASE + 'api/admin/coupon/'+couponId)
        .withCredentials()
        .end((err, res) => {
            if (err) {
            dispatch(getCouponDetailsFailure(err))
            alert("error: " + JSON.stringify(err));
            } else {
            dispatch(getCouponDetailsSuccess(res.body))
            }
        })
        }
    }


// WEBPACK FOOTER //
// ./src/actions/CouponDetails.js